import { CohortMemberCohortTypeEnum } from '../types';

export enum CohortType {
  Rollup = 'rollup',
  Base = 'base',
  Reset = 'reset',
}

export const cohortTypeSorted = [
  CohortMemberCohortTypeEnum.Global,
  CohortMemberCohortTypeEnum.Geo,
  CohortMemberCohortTypeEnum.Region,
  CohortMemberCohortTypeEnum.Shard,
  CohortMemberCohortTypeEnum.Db,
];

export type sloGroupSearchObjectType = {
  pageBase?: string;
  pageRollup?: string;
  cohortType?: CohortType;
  hasBreachStatusOnly?: string;
  hideDrafts?: string;
  isDraft?: string;
  geos?: string;
  regions?: string;
  shards?: string;
  tenants?: string;
  environments?: string;
  shardNames?: string;
  cloudIds?: string;
  customFilters?: string;
};
